// PATCH 36 Me2 — a small recently-viewed store shared across connectors, admin screens and other
// quick-access targets. Distinct from M12's project switcher (projects have their own recents there).
const KEY = "kadana_recents_v1";
const CAP = 12;

const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };

export function recordRecent({ type, id, label, to }) {
  if (!label || !to) return;
  const list = read().filter((x) => !(x.type === type && x.to === to));
  list.unshift({ type, id: id || to, label, to, at: Date.now() });
  try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, CAP))); } catch { /* ignore */ }
}

export function readRecents(type) {
  const list = read();
  return type ? list.filter((x) => x.type === type) : list;
}

export function clearRecents() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
